import {getBlockAbove} from "./getBlockAbove.js";
import {isAncestorEmpty} from "./isAncestorEmpty.js";
export const isBlockAboveEmpty = (editor) => {
  const block = getBlockAbove(editor)?.[0];
  if (!block)
    return false;
  return isAncestorEmpty(editor, block);
};
